import { render } from "./AdminCourseItem.vue?vue&type=template&id=2c1977cc&scoped=true"
import script from "./AdminCourseItem.vue?vue&type=script&lang=js"
export * from "./AdminCourseItem.vue?vue&type=script&lang=js"

import "./AdminCourseItem.vue?vue&type=style&index=0&id=2c1977cc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1977cc"]])

export default __exports__